<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2025-05-27 18:12:16
 * @Description: 设置剖切盒子是否显示
 * @LastEditors: heqing heqing@wiz.top
-->
<template>
  <div class="position-absolute p-10px left-container" :style="{ top: top, height: height }">
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-b-5px">设置剖切盒子</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>

    <div class="h-[calc(100%-60px)] mt-10px">
      <el-row type="flex" align="middle" class="clip-Tool" justify="space-between">
        <el-col :span="18">
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-checkbox-group v-model="clipList" class="p-l-10px clip-tool-box" @change="onChange">
              <el-checkbox label="包围盒"></el-checkbox>
              <el-checkbox label="操作轴"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <div class="clipList-box m-t-10px fz-14 p-10px p-t-10px">
        <el-row justify="space-between" class="clipTitle">
          <el-col :span="7"
            ><i class="el-icon-document m-r-5px"></i
            >{{ this.clipData.clipType | clipNameFilter }}</el-col
          >
          <el-col :span="8" class="tr">
            <el-input
              @keyup.enter.native="getClipRecordList('referch')"
              size="small"
              clearable
              placeholder="请输入内容"
              v-model.trim="params.KeyWords"
            ></el-input
          ></el-col>
          <el-col :span="3" class="m-r-6px">
            <el-tooltip content="搜索" placement="top" :open-delay="1000">
              <el-button
                type="primary"
                @click="getClipRecordList('referch')"
                size="mini"
                icon="el-icon-search"
                class="m-l-5px"
              ></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="mini" @click="openClipDialog('')">保存剖切</el-button>
          </el-col>
        </el-row>
        <el-row class="tabs-content m-t-5px" v-loading="isloading">
          <div class="tab-content-item" v-for="(item, index) in clipRecordList" :key="index">
            <img :src="item.imageContent" alt="" @click="viewItem(item)" />
            <div class="flex tab-item-title">
              <div>
                <span>{{ item.seqNo }}</span>
                <span class="p-l-5px p-r-5px fz-12">{{ item.fileName }}</span>
                <el-tooltip content="编辑" placement="top" :open-delay="1000">
                  <i class="el-icon-edit" @click="openClipDialog(item)"></i>
                </el-tooltip>
              </div>
              <div>
                <el-tooltip content="删除" placement="top" :open-delay="1000">
                  <i @click="deleteItem(item.id)" class="el-icon-delete"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="flex w-full h-full justify-center items-center" v-if="!clipRecordList.length">
            暂无数据！
          </div>
        </el-row>
      </div>
      <div class="tc m-t-5px">
        <el-pagination
          background
          @size-change="getClipRecordList('referch')"
          @current-change="getClipRecordList"
          :current-page.sync="params.PageNo"
          :page-size.sync="params.PageSize"
          layout="total, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="isAdd ? '新增剖切' : '编辑剖切'"
      :visible.sync="clipDialogShow"
      @close="cancelClipDialog"
      width="30%"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <el-form
        :model="clipForm"
        label-width="70px"
        :rules="clipRules"
        label-position="left"
        ref="addEditForm"
      >
        <el-form-item label="序号" prop="seqNo">
          <el-input v-model.trim="clipForm.seqNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="剖切方式">
          <el-input
            disabled
            :value="clipForm.sectioningType | clipNameFilter"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件名称" prop="fileName">
          <el-input v-model="clipForm.fileName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClipDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submitClip" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <img :src="imgChangeUrl" alt="" id="rotateImg" v-if="true" />
  </div>
</template>

<script>
import ClipToolServer from '@/services/clipTool'
import { ThreeDimensionalSectioningApi, FileApi } from '@/services/cloud-render-management'
import { cilpSetting, cancelClip, updateAxis } from '../js/clip'

export default {
  name: 'ClipTool',
  props: ['clipData', 'player', 'height', 'top', 'currentFileId', 'cloudRender'],
  data() {
    const checkSeq = (rules, value, callback) => {
      if (!_.isSafeInteger(_.toNumber(value))) {
        callback(new Error('序号必须为整数类型'))
      } else {
        callback()
      }
    }
    return {
      clipList: ['包围盒', '操作轴'],
      clipRecordList: [],
      params: {
        PageSize: 5,
        PageNo: 1,
        KeyWords: '',
        SiteId: '',
        SectioningType: '',
        DocumentFileId: '',
      },
      pageTotal: 10,
      clipDialogShow: false, // 保存或者编辑剖切弹框显示与否
      isAdd: true, // 是否是新增操作
      isloading: false, // 是否正在加载中
      clipForm: {
        seqNo: '',
        fileName: '',
        sectioningType: '',
        imgUrl: '',
        documentFileId: '',
        content: '',
        screenshotAttachmentId: '',
        siteId: '',
      },
      clipObjParams: {
        // 存在刨切的数据
        clipData: '',
        clipObjCodes: [],
      },
      clipEnumList: {
        // 剖切枚举
        AllClip: 1,
        PartClipBox: 2,
        ThreePanel: 3,
      },
      imgChangeUrl: '', // 截图翻转之前的路径
      showTemporaryImg: false, // 临时展示的翻转后的模型截图
      clipRules: {
        seqNo: [
          { required: true, message: '请输入内容', trigger: 'change' },
          { required: true, validator: checkSeq, trigger: 'change' },
        ],
        fileName: [{ required: true, message: '请输入内容', trigger: 'change' }],
      },
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  filters: {
    clipNameFilter(val) {
      switch (val) {
        case 'AllClip':
          return '全局剖切'
        case 'PartClipBox':
          return '局部剖切'
        default:
          return '三面剖切'
      }
    },
  },
  watch: {
    'clipData.clipType': {
      handler(val) {
        if (val) {
          this.getClipRecordList('referch')
          this.setClip(val)
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.cloudRender.Clip.cancelClip()
  },
  methods: {
    // 设置剖切
    async setClip(val) {
      let currentNode = null
      let clipDataType = 1
      const clipNode = await this.cloudRender.NodeProxy.getRoot()
      if (!clipNode) return
      const currentRoot = clipNode
      if (this.clipEnumList[val]) {
        const selectNode = await this.cloudRender.NodeProxy.getSeletedNodes()
        clipDataType = 1
        currentNode =
          selectNode && selectNode.status && selectNode.data?.length
            ? selectNode.data[0]
            : currentRoot
      }
      const options = {
        setIsInside: this.clipEnumList[val] === 3,
        setPartCilp: this.clipEnumList[val] === 2,
      }
      this.$set(options, 'node', currentNode)
      console.log(this.cloudRender.Clip, 'dd', this.player, '33')
      await this.cloudRender.Clip.createClip(
        clipDataType,
        this.clipEnumList[val] === 3 ? 3 : 0,
        options
      )
      console.log(this.cloudRender, 'this.cloudRender')
      this.player.Native.ClipBox.setProperty(this.cloudRender.Clip.clipObj, {
        frontColor: 0xddddff10,
        backColor: 0xddddff10,
      })
    },
    // 查看每一项的剖切状态
    async viewItem(item) {
      await this.cloudRender.Clip.cancelClip()
      // 移动相机
      const contentObj = JSON.parse(item.content)
      const cameraLocation = contentObj.cameraLocation
      this.cloudRender.Camera.moveCamera('CameraParam', cameraLocation, 1)
      // 启用剖切
      const options = {
        setIsInside: item.sectioningType === 3,
        setPartCilp: item.sectioningType === 2,
        clipData: contentObj.clipData,
      }
      this.cloudRender.Clip.createClip(2, item.sectioningType === 3 ? 3 : 0, options)
    },
    async getImageContent(id) {
      // 获取图片内容
      const result = await FileApi.getPublicImageBaseString(id)
      if (result) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 获取记录列表
    async getClipRecordList(type) {
      this.isloading = true
      this.params.SectioningType = this.clipEnumList[this.clipData.clipType]
      if (type === 'referch') {
        this.params.PageNo = 1
      }
      const res = await ThreeDimensionalSectioningApi.queryList({
        documentFileId: this.currentFileId,
        sectioningType: this.params.SectioningType,
        sorting: 'seqNo',
        skipCount: (this.params.PageNo - 1) * this.params.PageSize, // Number |
        maxResultCount: this.params.PageSize, // Number |
      })
      if (res) {
        this.clipRecordList = res.items
        this.clipRecordList.forEach(async (item) => {
          const imgRes = await this.getImageContent(item.screenshotAttachmentId)
          this.$set(item, 'imageContent', imgRes)
        })
        this.pageTotal = res.totalCount
      } else {
        this.clipRecordList = []
        this.pageTotal = 0
      }
      this.isloading = false
    },
    // 打开保存或编辑当前剖切记录弹框
    async openClipDialog(val) {
      this.clipDialogShow = true
      this.isAdd = !val
      this.clipForm.sectioningType = this.clipData.clipType
      if (val) {
        this.clipForm.fileName = val.fileName
        this.clipForm.seqNo = val.seqNo
        this.clipForm.id = val.id
        this.clipForm.content = val.content
        this.clipForm.screenshotAttachmentId = val.screenshotAttachmentId
        this.clipForm.documentFileId = val.documentFileId
      }
      // 新增操作时，截图操作
      const captureDom = document.querySelector('#engineId')
      this.showTemporaryImg = true
      this.imgChangeUrl = await this.getConvertToImage(captureDom)
      setTimeout(async () => {
        const captureDomAfter = document.querySelector('#rotateImg')
        this.clipForm.imgUrl = await this.getConvertToImage(captureDomAfter)
        this.showTemporaryImg = false
      }, 0)
      // 新增时获取刨切数据包
      this.clipObjParams = this.$options.data().clipObjParams
      const res = await this.cloudRender.Clip.getClipData()
      if (res && res.status && res.data) {
        this.clipObjParams.clipData = res.data
      }
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(container).width)
      const height = parseInt(window.getComputedStyle(container).height)
      // // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: true,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        return canvas.toDataURL('image/png')
      })
    },
    // 图片转文件
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    // 关闭弹框
    cancelClipDialog() {
      this.clipDialogShow = false
      this.clipForm = this.$options.data().clipForm
      this.$refs.addEditForm.resetFields()
    },
    // 弹框确定操作
    submitClip() {
      this.$refs.addEditForm.validate(async (valid) => {
        if (valid) {
          // 摄像头位置
          const cameraData = await this.cloudRender.Camera.getCurrentCamera()
          this.clipObjParams.cameraLocation = cameraData.data || {}
          this.clipForm.content = JSON.stringify(this.clipObjParams)
          // 新增操作
          // 剖切截图上传
          const file = await this.dataURLtoFile(this.clipForm.imgUrl, `${this.generateUUID()}.png`)
          const formData = new FormData()
          formData.append('files', file)
          const res = await FileApi.upload_0({
            url: { authLevel: 2 },
            body: formData,
          })
          if (this.isAdd) {
            if (res && res.length) {
              const query = {
                content: this.clipForm.content,
                screenshotAttachmentId: res[0].id, // 截图文件id
                fileName: this.clipForm.fileName,
                documentFileId: this.currentFileId,
                sectioningType: this.clipEnumList[this.clipForm.sectioningType],
                seqNo: this.clipForm.seqNo,
                siteId: this.currentProject ? this.currentProject.id : ' ',
              }
              const result = await ThreeDimensionalSectioningApi.create(query)
              if (result) {
                this.$message.success('新增成功！')
              } else {
                this.$message.error(result.message)
              }
            }
          } else {
            // 编辑操作
            const resultEdit = await ThreeDimensionalSectioningApi.update(this.clipForm.id, {
              id: this.clipForm.id,
              screenshotAttachmentId: res[0].id,
              content: this.clipForm.content,
              fileName: this.clipForm.fileName,
              sectioningType: this.clipEnumList[this.clipForm.sectioningType],
              documentFileId: this.currentFileId,
              seqNo: this.clipForm.seqNo,
              siteId: this.currentProject ? this.currentProject.id : ' ',
            })
            if (resultEdit) {
              this.$message.success('编辑成功！')
            } else {
              this.$message.error(result.message)
            }
          }
          this.getClipRecordList()
          this.clipDialogShow = false
        }
      })
    },
    // 删除操作
    async deleteItem(val) {
      await ThreeDimensionalSectioningApi.callDelete_0(val)

      this.$message.success('删除成功！')
      this.getClipRecordList('referch')
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    onChange() {
      this.cloudRender.Clip.setVisible(['Panel'], this.clipList.includes('包围盒'))
      this.cloudRender.Clip.setVisible(['Axis'], this.clipList.includes('操作轴'))
    },
    closeComponents() {
      this.$emit('closeComponents', this.clipData.clipType)
    },
  },
}
</script>
<style lang="scss">

@import '../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../css/component.scss';

#clip {
  width: 368px;
  background-color: rgba(46, 107, 176, 0.5) !important;
  border-radius: 4px;
  z-index: 99;
  padding: 10px;
  left: 35px;
  border: none;
}
/deep/.el-card {
  &__body {
    padding: 0 !important;
    .clip-Tool {
      height: 36px;
      background-color: rgba(24, 41, 72, 0.5) !important;
      border-radius: 2px;
    }
  }
}
.clipList-box {
  background-color: rgba(24, 41, 72, 0.5) !important;
  border-radius: 2px;
  height: calc(100% - 100px);
  overflow: hidden;
  color: #fff;
  .tabs-content {
    height: calc(100% - 50px) !important;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      background: transparent;
    }
    .tab-content-item {
      margin-top: 10px;
      &:first-of-type {
        margin-top: 0;
      }
      img {
        vertical-align: top;
        height: 130px;
        width: 100%;
        border-radius: 5px 5px 0 0;
      }
      .tab-item-title {
        padding: 2px 5px;
        justify-content: space-between;
        background: #46a6ff9c;
        border-radius: 0 0 5px 5px;
      }
    }
  }
}
.clipTitle {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 32px;
}
#rotateImg {
  transform: rotateX(180deg);
  margin-top: 40px;
}

.text-color-white {
  color: white;
}
.fz-12 {
  font-size: 12px;
}
.fz-14 {
  font-size: 14px;
}
.m-t-10px {
  margin-top: 10px;
}
.m-t-5px {
  margin-top: 5px;
}
.m-r-6px {
  margin-right: 6px;
}
.p-l-10px {
  padding-left: 10px;
}
::v-deep .clip-tool-box .el-checkbox {
  margin-bottom: 0px;
}

</style>
